module.exports = __webpack_public_path__ + "static/img/android.b28ac05a.png";